import { QuantityUnitSetting } from "../models/Settings";
import { runAction } from "./client";
import { Measures } from "./Misc/index";

export interface SettingsRequest
{
    DivisionId: number;
    PreferredUnits: QuantityUnitSetting[];
    EmailAddresses: string;

    Locale: string;
    NewPassword: string;
    DontAlertLeavingRed: boolean;
    DontAlertEnteringYellow: boolean;
    DontAlertLeavingYellow: boolean;
}

export interface Settings
{
    EmailAddresses: string;
    Measures: Measures;
    DontAlertLeavingRed: boolean;
    DontAlertEnteringYellow: boolean;
    DontAlertLeavingYellow: boolean;
}

export interface GetSettingsFn
{
    (currentDivisionId: number): Promise<Settings>;
}

export const getSettings: GetSettingsFn = (divisionId: number) => {
    return runAction<Settings>('/action/GetSettings', { DivisionId: divisionId });
};

export interface SaveSettingsFn
{
    (request: SettingsRequest): Promise<{}>;
}

export const saveSettings: SaveSettingsFn = (request: SettingsRequest): Promise<{}> => {
    return runAction<{}>('/action/SaveSettings', request);
};




// WEBPACK FOOTER //
// ./src/rest/settings.ts